import type { FC } from 'react';
import { generatePath, Link } from 'react-router-dom';
import { InformationCircleIcon } from '@heroicons/react/outline';
import Nav from '@src/routes';

import { bannerContainerClasses } from '../classes';

interface ContractEndorsementBannerProps {
  name: string;
  parentId: string;
  isDisabled: boolean;
}

export const ContractEndorsementBanner: FC<ContractEndorsementBannerProps> = ({ name, parentId, isDisabled }) => {
  return (
    <div aria-disabled={isDisabled} className={bannerContainerClasses({ isDisabled })}>
      <InformationCircleIcon className="text-info-600 h-5 w-5" />
      <p className="font-normal text-black">
        You are viewing endorsement: {name} &rarr;
        <Link
          className="ml-2 cursor-pointer font-medium underline transition-colors hover:opacity-75"
          to={generatePath(Nav.SubmissionContract, { id: parentId })}
        >
          View original contract
        </Link>
      </p>
    </div>
  );
};
